import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AppErrorBoundary } from './components/AppErrorBoundary/AppErrorBoundary'
import './styles.css'
import './reader-experience.css'
import './signal-pages.css'
import './retention.css'
import './interaction-overrides.css'
import './trust-release.css'
import './audit-design.css'
import './theme.css'
import './article-media.css'
import { initializePerformanceMonitoring } from './services/analytics'
import { CommunityProvider } from './community/CommunityProvider'

const capture = new URLSearchParams(window.location.search).get('capture')
// Legacy public map links select a view, not a desktop-sized QA capture.
if (capture && !(window.location.pathname === '/us' && capture === 'places')) {
  document.documentElement.dataset.capture = 'true'
}

createRoot(document.getElementById('root')!).render(<StrictMode><AppErrorBoundary><CommunityProvider><App /></CommunityProvider></AppErrorBoundary></StrictMode>)
initializePerformanceMonitoring()
